import { FiShield, FiMonitor, FiLock, FiFileText } from 'react-icons/fi';
import Reveal from '../ui/Reveal';

const ITEMS = [
  {
    icon: FiShield,
    title: 'Automatic sensitive-data redaction',
    description: 'On every message, before it reaches the AI model.',
  },
  {
    icon: FiMonitor,
    title: 'Session management',
    description:
      'See every device signed in to your account, when it was last active, and its approximate location — remotely sign out any session you don\'t recognize.',
  },
  {
    icon: FiLock,
    title: 'Secure password handling',
    description:
      'A self-service password reset flow (one-time verification code by email) and the ability to change your password any time.',
  },
  {
    icon: FiFileText,
    title: 'Billing transparency',
    description: 'Every invoice, past and upcoming, is available to download as a PDF — with automatic renewal notifications.',
  },
];

export default function SecuritySection() {
  return (
    <section className="bg-midnight py-24 text-white">
      <div className="container-page flex flex-col items-center gap-14">
        <div className="flex max-w-2xl flex-col items-center gap-4 text-center">
          <span className="section-eyebrow border-brand-800/60 bg-brand-900/30 text-brand-300">Security</span>
          <h2 className="text-3xl font-bold tracking-tight sm:text-4xl">Security you can rely on</h2>
        </div>

        <div className="grid w-full grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-4">
          {ITEMS.map((item, index) => (
            <Reveal key={item.title} delay={index * 0.08} className="flex flex-col gap-4 rounded-2xl border border-midnight-600 bg-midnight-700 p-6">
              <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-brand-gradient text-white">
                <item.icon size={20} />
              </span>
              <h3 className="text-sm font-bold">{item.title}</h3>
              <p className="text-sm leading-relaxed text-subtle">{item.description}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
